import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InputText from "../InputText/InputText";
import { withTheme } from "styled-components";
import Center, { Stretch } from "../Center/Center";
import FileUpload from "../FileUpload/FileUpload";
import RichTextEditor, {
  Converter
} from "../../atomic/RichTextEditor/RichTextEditor";
import Information from "../Information/Information";
import Slider from "../Slider/Slider";
import CheckboxGroup from "react-checkbox-group";

const WithValidation = styled.div`
  width: ${props => props.width || "100%"};
  background-color: ${props => props.theme.color7};
  padding: 15px;
  font-size: 14px;
  margin-bottom: 5px;
`;
const ErrorBox = styled.div`
  width: 100%;
  color: red;
  margin-bottom: 5px;
`;

const Show = styled.div`
  width: ${props => props.width || "100%"};
  display: flex;
  color: rgba(0, 0, 0, 0.87);
  font-size: 16px;
  padding: 15px;
  font-weight: 400;
`;

const ShowLabel = styled.div`
  width: ${props => props.labelWidth || "200px"};
  color: rgba(0, 0, 0, 0.54);
  display: inline-block;
  font-size: 13px;
  line-height: 20px;
`;
const ShowEdit = styled(Show)`
  padding: 0;
  flex-wrap: wrap;
`;

const ShowValue = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Buttons = styled.div`
  width: 100%;
  display: flex;
  margin-top: 5px;
  button {
    padding: 5px 10px;
    margin-right: 10px;
    color: ${props => props.theme.color4};
    cursor: pointer;
    text-decoration: none;
    font-size: 12px;
    border: 0px solid;
  }
  .save {
    color: ${props => props.theme.color5};
    background-color: ${props => props.theme.color4};
  }
`;

const EditButton = styled.button`
  background-color: transparent;
  min-width: 20px;
  border: 0px solid;
  font-size: 16px;
  cursor: pointer;
  padding: 0px;
  svg {
    margin-left: 20px;
  }
`;

export default withTheme(
  React.forwardRef((props, ref) => {
    const {
      label,
      onChange,
      validate,
      value,
      canEdit,
      placeholder,
      theme,
      saving,
      required,
      field
    } = props;
    const [err, setErr] = useState("");
    const [val, setVal] = useState(value || "");
    useEffect(() => {
      if (!saving) {
        setVal(value || "");
      }
    }, [value, saving]);
    if (!canEdit) {
      return (
        <Show>
          <ShowLabel>{label}</ShowLabel>
          {value}
        </Show>
      );
    }
    return (
      <WithValidation width={props.width}>
        <ShowEdit>
          <ShowLabel>{label}</ShowLabel>
          <Stretch>
            <InputText
              onChange={e => {
                setErr("");
                setVal(e.target.value);
              }}
              value={val}
              placeholder={placeholder}
            />
            {err && <ErrorBox>{err}</ErrorBox>}
            {saving && saving === field && (
              <Buttons>
                <button className="save">
                  <FontAwesomeIcon
                    icon={["fas", "spinner"]}
                    size="1x"
                    color={theme.color5}
                    spin
                  />
                </button>
              </Buttons>
            )}
            {!(saving && saving === field) && (value || "") !== val && (
              <Buttons>
                <button
                  className="save"
                  onClick={() => {
                    if (validate) {
                      const e = validate(val);
                      if (e) {
                        setErr(e);
                        return;
                      }
                    }
                    onChange(val);
                  }}
                >
                  Save
                </button>
                <button
                  onClick={() => {
                    setVal(value);
                  }}
                >
                  Cancel
                </button>
              </Buttons>
            )}
          </Stretch>
        </ShowEdit>
      </WithValidation>
    );
  })
);

export const RangeEdit = withTheme(
  React.forwardRef((props, ref) => {
    const {
      label,
      onChange,
      validate,
      value,
      placeholder,
      theme,
      saving,
      required,
      field
    } = props;
    const [err, setErr] = useState("");
    const [val, setVal] = useState(value || [0, 18]);
    useEffect(() => {
      console.log("Here", saving, value);
      if (!saving) {
        setVal(value || [0, 18]);
      }
    }, [value, saving]);
    const eq = (v, c) => {
      return v[0] === c[0] && v[1] === c[1];
    };
    return (
      <WithValidation width={props.width}>
        <ShowEdit>
          <ShowLabel>{label}</ShowLabel>
          <Stretch>
            <Slider
              from={val[0]}
              to={val[1]}
              onChange={(from, to) => {
                setErr("");
                setVal([from, to]);
              }}
            />
            {err && <ErrorBox>{err}</ErrorBox>}
            {saving && saving === field && (
              <Buttons>
                <button className="save">
                  <FontAwesomeIcon
                    icon={["fas", "spinner"]}
                    size="1x"
                    color={theme.color5}
                    spin
                  />
                </button>
              </Buttons>
            )}
            {!(saving && saving === field) && !eq(value, val) && (
              <Buttons>
                <button
                  className="save"
                  onClick={() => {
                    if (validate) {
                      const e = validate(val);
                      if (e) {
                        setErr(e);
                        return;
                      }
                    }
                    onChange(val);
                  }}
                >
                  Save
                </button>
                <button
                  onClick={() => {
                    setVal(value || [0, 18]);
                  }}
                >
                  Cancel
                </button>
              </Buttons>
            )}
          </Stretch>
        </ShowEdit>
      </WithValidation>
    );
  })
);

export const CheckboxesEdit = withTheme(
  React.forwardRef((props, ref) => {
    const {
      label,
      onChange,
      validate,
      value,
      options,
      theme,
      saving,
      field
    } = props;
    const [err, setErr] = useState("");
    const [val, setVal] = useState(value || []);
    useEffect(() => {
      if (!saving) {
        setVal(value || []);
      }
    }, [value, saving]);
    return (
      <WithValidation width={props.width}>
        <ShowEdit>
          <ShowLabel>{label}</ShowLabel>
          <Stretch>
            <CheckboxGroup name="fruits" value={val} onChange={setVal}>
              {Checkbox => (
                <>
                  {options.map(o => (
                    <label>
                      <Checkbox value={o.key} /> {o.name}
                    </label>
                  ))}
                </>
              )}
            </CheckboxGroup>{" "}
            {err && <ErrorBox>{err}</ErrorBox>}
            {saving && saving === field && (
              <Buttons>
                <button className="save">
                  <FontAwesomeIcon
                    icon={["fas", "spinner"]}
                    size="1x"
                    color={theme.color5}
                    spin
                  />
                </button>
              </Buttons>
            )}
            {!(saving && saving === field) && (value || []) !== val && (
              <Buttons>
                <button
                  className="save"
                  onClick={() => {
                    if (validate) {
                      const e = validate(val);
                      if (e) {
                        setErr(e);
                        return;
                      }
                    }
                    onChange(val);
                  }}
                >
                  Save
                </button>
                <button
                  onClick={() => {
                    setVal(value || []);
                  }}
                >
                  Cancel
                </button>
              </Buttons>
            )}
          </Stretch>
        </ShowEdit>
      </WithValidation>
    );
  })
);
export const FileUploadEdit = ({
  label,
  folder,
  image,
  onUpload,
  id,
  addLabel,
  canEdit,
  help
}) => {
  return (
    <Show>
      <ShowLabel>{label}</ShowLabel>
      <div>
        <FileUpload
          folder={folder}
          image={image}
          onUpload={onUpload}
          id={id}
          canEdit={canEdit}
          addLabel={addLabel}
        />
        {help && <Information message={help} />}
      </div>
    </Show>
  );
};

export const TextEdit = withTheme(
  React.forwardRef((props, ref) => {
    const { label, onChange, value, theme, saving, canEdit, field } = props;
    const [dirty, setDirty] = useState(false);
    const [richTextState, setRichTextState] = useState(
      Converter.convertToState(value || "")
    );
    const setRt = v => {
      setDirty(true);
      setRichTextState(v);
    };
    useEffect(() => {
      if (!saving) {
        setRichTextState(Converter.convertToState(value || ""));
        setDirty(false);
      }
    }, [value, saving]);
    if (!canEdit) {
      return (
        <Show>
          <ShowLabel>{label}</ShowLabel>
          <ShowValue
            dangerouslySetInnerHTML={{
              __html: (value || "").split("undefined").join("500px")
            }}
          ></ShowValue>
        </Show>
      );
    }
    return (
      <WithValidation width={props.width}>
        <ShowEdit>
          <ShowLabel>{label}</ShowLabel>
          <Stretch>
            <RichTextEditor
              id="LoyalityDetails"
              editorState={richTextState}
              onChange={st => setRt(st)}
            />
            {saving && saving === field && (
              <Buttons>
                <button className="save">
                  <FontAwesomeIcon
                    icon={["fas", "spinner"]}
                    size="1x"
                    color={theme.color5}
                    spin
                  />
                </button>
              </Buttons>
            )}
            {!(saving && saving === field) && dirty && (
              <Buttons>
                <button
                  className="save"
                  onClick={() => {
                    onChange(Converter.convertFromState(richTextState));
                  }}
                >
                  Save
                </button>
                <button
                  onClick={() => {
                    setRichTextState(Converter.convertToState(value || ""));
                    setDirty(false);
                  }}
                >
                  Cancel
                </button>
              </Buttons>
            )}
          </Stretch>
        </ShowEdit>
      </WithValidation>
    );
  })
);
